import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Button, Label, Input, FormFeedback } from "reactstrap";
import { withTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';
import { checkFileValidation } from "../../Utils/Common";

const colourStyles = {
  control: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled
      ? undefined
      : isSelected
        ? styles.backgroundColor
        : isFocused
          ? "#fff"
          : "#fff",
    ':hover': {
      ...styles[':hover'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    },
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const AddTransaction = props => {
  //meta title
  document.title = 'Add Transaction';
  
  const { getRequest, postRequest, postRequestByFormData } = useRequests();
  const [isLoading, setIsLoading] = useState(true);
  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };

  const [propertyInfo, setPropertyInfo] = useState({
    token_price: 0,
    minimum_investment_allocation: 0
  });
  const [transferAmount, setTransferAmount] = useState(0);

  const [File, setFile] = useState();
  const [FileName, setFileName] = useState('');
  const saveFile = (e) => {
    if((e.target.files).length > 0) {
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);

      var validationRes = checkFileValidation(e.target.files[0]);
      if (!validationRes.status) {
        setFile();
        setFileName('');

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: validationRes.msg,
        }));
        resetAlertData();

        return false;
      }
    }
  };

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: null,
      property: null,
      number_of_tokens: '',
      is_used_euro_wallet: false,
      transaction_information: '',
    },
    validationSchema: Yup.object({
      user: Yup.object().nullable().required('Please select a user'),
      property: Yup.object().nullable().required('Please select a property'),
      number_of_tokens: Yup.string()
        .matches(/^[0-9]+$/, 'Please enter a valid number')
        .required('Number of tokens is required'),
      transaction_information: Yup.string()
        .required('Transaction information is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        if (FileName === '') {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Please select a transaction proof!',
          }));
          submit1.disabled = false;
          submit1.textContent = 'Add Transaction';
          return;
        }

        const tokenValue = values.number_of_tokens * propertyInfo.token_price;
        if (tokenValue < propertyInfo.minimum_investment_allocation) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: 'Minimum investment allocation is required',
          }));
          submit1.disabled = false;
          submit1.textContent = 'Add Transaction';
          return;
        }

        const formData = new FormData();
        formData.append("p_id", values.property.value);
        formData.append("u_id", values.user.value);
        formData.append("currency", "Euro");
        formData.append("number_of_tokens", values.number_of_tokens);
        formData.append("is_used_euro_wallet", false);
        formData.append("transfer_euro", transferAmount);
        formData.append("transaction_information", values.transaction_information);
        formData.append("file", File);
        formData.append("fileName", FileName);
        
        const res = await postRequestByFormData('property-invest-by-bank', formData);
        if (res && res.code === 200) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
          
          // Reset form
          validation1.resetForm();
          setFile(null);
          setFileName('');
          setTransferAmount(0);
          setPropertyInfo({ token_price: 0, minimum_investment_allocation: 0 });
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        
        
        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = 'Add Transaction';
      } catch (error) {
        console.error("Error : ", error);
        let submit1 = document.getElementById('submit1');
        submit1.disabled = false;
        submit1.textContent = 'Add Transaction';
      }
    },
  });

  const handleUserChange = async (selectedUser) => {
    validation1.setFieldValue('user', selectedUser);
    validation1.setFieldTouched('user', true);
  };

  const handlePropertyChange = async (selectedProperty) => {
    validation1.setFieldValue('property', selectedProperty);
    validation1.setFieldTouched('property', true);
    
    if (selectedProperty && selectedProperty.value) {
      try {
        const jsonpar = JSON.stringify({
          p_id: selectedProperty.value
        });
        const res = await postRequest('get-property-info', jsonpar);
        if (res && res.code === 200) {
          setPropertyInfo(res.data.property);
        }
      } catch (error) {
        console.error("Error fetching property info:", error);
      }
    }
  };

  const handleChangeNumberOfTokens = (tokenCount, isUsedEuroWallet) => {
    if (!propertyInfo.token_price) return;
    
    const tokenValue = tokenCount * propertyInfo.token_price;
    
    setTransferAmount(tokenValue);
  };

  const [PropertiesData, setPropertiesData] = React.useState([]);
  const handleLoadGetProperties = async () => {
    setIsLoading(true);

    try {
      const res = await getRequest('get-properties');
      if (res && res.code === 200) {
        let tempArr = [];
        res.data.forEach(element => {
          if (element.property_status.toLowerCase() === 'open') {
            let temp = {
              label: element.property_name,
              value: element.p_id,
            };
            tempArr.push(temp);
          }
        });
        tempArr = [{
          options: tempArr
        }];
        setPropertiesData(tempArr);
      }
      else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: res.message,
        }));
      }
      resetAlertData();
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const [UsersData, setUsersData] = React.useState([]);
  const handleLoadGetUsers = async () => {
    setIsLoading(true);

    try {
      const res = await getRequest('get-users');
      if (res && res.code === 200) {
        let tempArr = [];
        res.data.forEach(element => {
          let temp = {
            label: `${element.first_name} ${element.last_name} (${element.email})`,
            value: element.u_id,
          };
          tempArr.push(temp);
        });
        tempArr = [{
          options: tempArr
        }];
        setUsersData(tempArr);
      }
      else {
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: res.message,
        }));
      }
      resetAlertData();
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      handleLoadGetProperties();
    }
  }

  React.useEffect(() => {
    handleLoadGetUsers();
  }, []);

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Add Transaction")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {isLoading ? (
                    <div className="d-flex flex-column align-items-center">
                      <div className="spinner-border text-green mb-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="text-green mb-0 fw-medium">Loading data...</p>
                    </div>
                  ) : (
                    <Row>
                      <Col md={6} xs="12">
                        <div className="mb-3 Register-Select2">
                          <Label className="form-label">Select User :</Label>
                          <Select 
                            styles={colourStyles} 
                            value={validation1.values.user} 
                            onChange={handleUserChange}
                            onBlur={() => validation1.setFieldTouched('user', true)}
                            options={UsersData} 
                            classNamePrefix="select2-selection"
                            placeholder="Search and select user..."
                            isClearable
                          />
                          {validation1.touched.user && validation1.errors.user ? (
                            <div className="invalid-feedback" style={{ display: 'block', color: '#f46a6a', backgroundColor: 'transparent', fontSize: '12px !important', marginTop: '0.25rem' }}>
                              {validation1.errors.user}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6} xs="12">
                        <div className="mb-3 Register-Select2">
                          <Label className="form-label">Select Property :</Label>
                          <Select 
                            styles={colourStyles} 
                            value={validation1.values.property} 
                            onChange={handlePropertyChange}
                            onBlur={() => validation1.setFieldTouched('property', true)}
                            options={PropertiesData} 
                            classNamePrefix="select2-selection"
                            placeholder="Search and select property..."
                            isClearable
                          />
                          {validation1.touched.property && validation1.errors.property ? (
                            <div className="invalid-feedback" style={{ display: 'block', color: '#f46a6a', backgroundColor: 'transparent', fontSize: '12px !important', marginTop: '0.25rem' }}>
                              {validation1.errors.property}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6} xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Number of Tokens :</Label>
                          <Input
                            name="number_of_tokens" 
                            type="text" 
                            placeholder="Enter number of tokens"
                            onChange={(e) => {
                              validation1.handleChange(e);
                              handleChangeNumberOfTokens(e.target.value, validation1.values.is_used_euro_wallet);
                            }}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.number_of_tokens || ""}
                            invalid={
                              validation1.touched.number_of_tokens && validation1.errors.number_of_tokens ? true : false
                            }
                          />
                          {validation1.touched.number_of_tokens && validation1.errors.number_of_tokens ? (
                            <FormFeedback type="invalid">{validation1.errors.number_of_tokens}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      {transferAmount > 0 && (
                        <Col md={6} xs="12">
                          <div className="mb-3">
                            <Label className="form-label">Transfer Amount :</Label>
                            <Input
                              type="text" 
                              value={`€${transferAmount}`}
                              disabled
                            />
                          </div>
                        </Col>
                      )}
                      <Col md={6} xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Transaction Information :</Label>
                          <Input
                            name="transaction_information" 
                            type="text" 
                            placeholder="Enter transaction information"
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            value={validation1.values.transaction_information || ""}
                            invalid={
                              validation1.touched.transaction_information && validation1.errors.transaction_information ? true : false
                            }
                          />
                          {validation1.touched.transaction_information && validation1.errors.transaction_information ? (
                            <FormFeedback type="invalid">{validation1.errors.transaction_information}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6} xs="12">
                        <div className="mb-3">
                          <Label className="form-label">Upload Transaction Proof :</Label>
                          <Input
                            type="file"
                            className="form-control"
                            onChange={saveFile}
                            accept=".pdf,.jpg,.jpeg,.png"
                          />
                          {FileName && (
                            <div className="mt-2">Selected file: {FileName}</div>
                          )}
                        </div>
                      </Col>
                      {propertyInfo.minimum_investment_allocation > 0 && (
                        <Col xs={12}>
                          <div className="alert alert-info">
                            <strong>Minimum investment allocation:</strong> {formatCurrency(propertyInfo.minimum_investment_allocation)}
                          </div>
                        </Col>
                      )}
                      <Col xs={12}>
                        <div className="text-left mt-2">
                          <Button
                            type="button" 
                            color="primary"
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          >
                            Add Transaction
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(AddTransaction);